// Este archivo es generado automáticamente. No modificar manualmente.
export const version = '1.2.0';
export const versionDate = '24/09/2025';
